import { sortBy } from 'lodash-es';
import React from 'react';
import { connect } from 'react-redux';
import { Card, Icon, Label, Table } from 'semantic-ui-react';
import { jobsStateType } from '../../../../types';
import Loading from '../../../Loading';
import moment from 'moment';

const getSeverityColor = s => {
  switch (s) {
    case 'DEBUG':
      return 'grey';
    case 'WARNING':
      return 'yellow';
    case 'ERROR':
      return 'red';
    case 'INFO':
    default:
      return 'blue';
  }
};

const headers = ['Date', 'Log Level', 'Text'];
const renderRow = () => ({ id, severity, text }) => ({
  key: id.logDate,
  cells: [
    {
      key: 'log-date',
      content: moment(id.logDate).toISOString(),
      textAlign: 'center'
    },
    {
      key: 'log-severity',
      content: <Label color={getSeverityColor(severity)}>{severity}</Label>,
      textAlign: 'center'
    },
    {
      key: 'log-msg',
      content: text,
      textAlign: 'left'
    }
  ]
});

const JobLogTable = ({ jobSelected, isLoading }) => {
  if (!jobSelected || !jobSelected.lastInstance) {
    return (
      <Card fluid raised>
        <Card.Content>Please select a job first</Card.Content>
      </Card>
    );
  }
  const { logs, lastInstance } = jobSelected;
  const { jobInstanceId, triggeredBy, startTime } = lastInstance;
  return (
    <Card fluid raised>
      <Loading isLoading={isLoading} />
      <Card.Content style={{ minHeight: '210px' }}>
        <Label image ribbon color="teal">
          <Icon name="settings" />
          {jobInstanceId}
          <Label.Detail>{`Started at ${startTime} by ${triggeredBy}`}</Label.Detail>
        </Label>
        <Table
          renderBodyRow={renderRow()}
          tableData={sortBy(logs, ['id.logDate'])}
          headerRow={headers}
        />
      </Card.Content>
    </Card>
  );
};

JobLogTable.propTypes = {
  ...jobsStateType.isRequired
};

const mapStateToProps = state => ({
  jobSelected: state.jobs.data.jobSelected,
  isLoading: state.jobs.isLoading.jobSelected
});

export default connect(mapStateToProps)(JobLogTable);
